import React, { Component } from "react";
import ProjectTable from "./ProjectTable";
import BsyTurnPage from "../BsyTurnPage";
import BsySLoading from "../BsySLoading";
import { BsyUtils } from "../../utils/Utils";
import { dayjsUtils } from "../../utils/dayjsUtils";

class InstallUpdateLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skip: 0,
      count: 0,
      limit: 20,
      selectVal: props.data || {},
      keyword: props.keyword || "",
      header: [
        {
          name: React.language("project.site"),
          id: "siteLog",
        }, {
          name: React.language("project.user.account"),
          id: "accountLog",
        }, {
          name: React.language("project.user.name"),
          id: "nameLog",
        }, {
          name: React.language("install.version"),
          id: "versionLog",
        }, {
          name: React.language("installation.time"),
          id: "timeLog",
        }, {
          name: React.language("type.operation"),
          id: "typeLog",
        }
      ],
      data: [],
      isLoading: true
    }
  }

  componentDidMount() {
    this.loadData();
    this.props.getContext(this);
  }

  loadData = () => {
    const {skip, limit, selectVal, keyword} = this.state;
    this.setState({isLoading: true}, ()=>{
      React.axios("/dashboard/standard_install_log",{
        keyword: keyword,
        _id: selectVal._id,
        skip: skip * limit,
        limit
      }).then(res => {
        const {list, count} = res.data;
        this.setState({data: list, count, isLoading: false})
      })
    })
  }

  skipChange = (e) => {
    this.setState({
      skip: e
    }, () => {
      this.loadData();
    })
  }

  listLimitChange = (e) => {
    this.setState({
      limit: e,
      skip: 0
    }, () => {
      this.loadData();
    })
  }

  render() {
    const {limit, skip, count, header, data, isLoading} = this.state;
    return <div className="InstallUpdateLog">
      <div className="ProjectTable">
        {isLoading && <BsySLoading style={{background: '#ffffff'}}/>}
        <div className="table-content">
          <div className="content-header">
            <div className="header-tr">
              {
                header.map(res => {
                  return <div className={`header-td ${res.id}`}>{res.name}</div>
                })
              }
            </div>
          </div>
          <div className="content-body">
            {
              data.map((res, key) => {
                return <div className={`body-tr ${key % 2 === 0 ? "" : "even"}`}>
                  <div className={`body-td siteLog`}><input type="text" value={res.sitedomain} readOnly={true}/></div>
                  <div className={`body-td accountLog`}>{res.account}</div>
                  <div className={`body-td nameLog`}>{res.username}</div>
                  <div className={`body-td versionLog`}>{res.version}</div>
                  <div className={`body-td timeLog`}>{BsyUtils.date2Str(dayjsUtils.timeToTZ(res.createTime), "yyyy-MM-dd HH:mm:ss")}</div>
                  <div className={`body-td typeLog state-${res.type}`}>{res.typeText}</div>
                </div>
              })
            }
          </div>
        </div>
      </div>
      <BsyTurnPage skipChange={this.skipChange} listLimitChange={this.listLimitChange} limit={limit} skip={skip} count={count} />
    </div>
  }
}

export default InstallUpdateLog;